import { Webhook } from "../common/model/objectTypes"
import { menuItem } from "../utils/constants"
import { WEBHOOK_INFO, WEBHOOK_PRODUCT_INFO, WEBHOOK_SPECIFICATION } from "../utils/webhook/webhookDescriptions"
import { clientManagementTestConnectionBody, SUITE_ClientManagement_DocumentSignedBody } from "../utils/webhook/webhookObjects"
import { clientInformationJsonResponse, testConnectionJsonResponse } from "../utils/webhook/webhookResponseJson"

const documentSigned :Webhook= {
    name: menuItem.clientInformationChange,
    productInfo: WEBHOOK_PRODUCT_INFO.ClMgnt,
    webhookInfo:WEBHOOK_INFO.ClMgnt,
    webhookSpecifications:WEBHOOK_SPECIFICATION.SUITE.clientManagement_clientInformationChange,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: clientManagementTestConnectionBody,
    responseBody: SUITE_ClientManagement_DocumentSignedBody,
    jsonResponse: clientInformationJsonResponse,
}

export const getContent = (webhookName :string) => {    
    switch (webhookName) {
        case menuItem.clientInformationChange:
            return documentSigned;
    }
}